export const ActionTypes = {
  UPDATE_ADDRESS_ARRAY: "UPDATE_ADDRESS_ARRAY",
  UPDATE_EMPLOYMENT_EDUCATION_ARRAY: "UPDATE_EMPLOYMENT_EDUCATION_ARRAY",
  UPDATE_EDUCATION_ADDRESS_MISMATCH: "UPDATE_EDUCATION_ADDRESS_MISMATCH",
  UPDATE_EMPLOYMENT_ADDRESS_MISMATCH: "UPDATE_EMPLOYMENT_ADDRESS_MISMATCH"
};
